entryIterator